













































import Vue, { PropOptions } from 'vue';
import STooltip from '../../STooltip/STooltip.vue';
import { AppRouteSectionAction } from '../../../data/routes';

export default Vue.extend({
  name: 'SNavigationSectionHeading',
  components: {
    STooltip,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    action: {
      type: Object,
      required: false,
    } as PropOptions<AppRouteSectionAction>,
    showDivider: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
});
